import { message, Modal } from '@whalecloud/fdx';
import { i18n } from 'fishx';
import {
  getTenancyUsers,
  getTenancyChild,
  lockUser,
  unLockUser,
  disableUser,
  enableUser,
  addTenancyUser,
  updateTenancyUser,
  getRoles,
  getRolesByUserId,
  changeUserRoles,
  resetPwd,
  getCurrentUserSp,
} from '@pages/MvnoUserMgr/services/tenancyUser';

export default {
  namespace: 'tenancyUser',

  state: {
    users: [],
    child: [],
    pagination: {
      current: 0,
      pageSize: 10,
      total: 10,
    },
    fetchParams: {
      pageIndex: 0,
      pageLen: 10,
    },
    roles: [],
    ownRoles: [],
    spId: '',
    self: {},
    selectedRow: {},
    modalVisible: false,
    operation: '',
    grantVisible: false,
  },

  effects: {
    *fetchTenancyUsers({ payload = {} }, { call, put, select }) {
      const { fetchParams } = yield select(state => state.tenancyUser);
      const params = { ...fetchParams, ...payload };
      const { data, success } = yield call(getTenancyUsers, params);
      if (success) {
        const { list = [], pageSize, pageNum, total } = data;
        const { spId } = params;
        yield put({
          type: 'save',
          payload: {
            users: list || [],
            pagination: {
              current: pageNum,
              pageSize,
              total,
            },
            fetchParams: params,
            spId: spId || '',
            selectedRow: list[0] || {},
          },
        });
      }
    },

    // *updateFetchParams({ payload = {} }, { call, put }) {
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       fetchParams: payload,
    //     },
    //   });
    // },

    *fetchTenancyChild(_, { call, put }) {
      const { data, success } = yield call(getTenancyChild);
      const { data: sp, success: successSp } = yield call(getCurrentUserSp);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            child: data,
          },
        });
      }
      if (successSp) {
        const self = {
          spId: sp.CURRENT_SP,
          spName: sp.CURRENT_SP_NAME,
        };
        yield put({
          type: 'save',
          payload: {
            self,
          },
        });
      }
    },

    *addTenancyUser({ payload }, { call, put }) {
      const params = { ...payload };
      const { success, errorMsg } = yield call(addTenancyUser, params);
      if (success) {
        message.success(i18n('MULTITENANCYUSERMGR_ADD_USER_SUCCESS'));
        yield put({
          type: 'fetchTenancyUsers',
        });
      } else {
        Modal.error({
          title: 'Error',
          content: errorMsg,
          centered: true,
        });
      }
    },

    *updateTenancyUser({ payload }, { call, put }) {
      const { success } = yield call(updateTenancyUser, payload);
      if (success) {
        message.success(i18n('MULTITENANCYUSERMGR_MOD_USER_SUCCESS'));
        yield put({
          type: 'fetchTenancyUsers',
        });
      }
    },

    *lockUser({ payload }, { call, put, select }) {
      const { userId } = payload;
      const { success, data } = yield call(lockUser, userId);
      if (success && data === 'success') {
        message.success(i18n('MULTITENANCYUSERMGR_LOCK_USER_SUCCESS'));
        const tenancyUser = yield select(state => state.tenancyUser);
        const newUsers = [...tenancyUser.users];

        const index = newUsers.findIndex(item => item.userId === userId);
        if (index > -1) {
          const item = newUsers[index];
          newUsers.splice(index, 1, {
            ...item,
            isLocked: 'Y',
          });
          yield put({
            type: 'save',
            payload: {
              users: newUsers,
            },
          });
        }
      }
    },

    *unLockUser({ payload }, { call, put, select }) {
      const { userId } = payload;
      const { success, data } = yield call(unLockUser, userId);
      if (success && data === 'success') {
        message.success(i18n('MULTITENANCYUSERMGR_UNLOCK_USER_SUCCESS'));
        const tenancyUser = yield select(state => state.tenancyUser);
        const newUsers = [...tenancyUser.users];

        const index = newUsers.findIndex(item => item.userId === userId);
        if (index > -1) {
          const item = newUsers[index];
          newUsers.splice(index, 1, {
            ...item,
            isLocked: 'N',
          });
          yield put({
            type: 'save',
            payload: {
              users: newUsers,
            },
          });
        }
      }
    },

    *disableUser({ payload }, { call, put }) {
      const { userId } = payload;
      const { success, data } = yield call(disableUser, userId);
      if (success && data === 'success') {
        message.success(i18n('MULTITENANCYUSERMGR_DISABLE_USER_SUCCESS'));

        yield put({
          type: 'fetchTenancyUsers',
        });
        //   const { filterParam } = yield select(state => state.userMgr);
        //   yield put({
        //     type: 'fetch',
        //     payload: {
        //       ...filterParam,
        //     },
        //   });
      }
    },
    *enableUser({ payload }, { call, put }) {
      const { userId } = payload;
      const { success, data } = yield call(enableUser, userId);
      if (success && data === 'success') {
        message.success(i18n('MULTITENANCYUSERMGR_ENABLE_USER_SUCCESS'));

        yield put({
          type: 'fetchTenancyUsers',
        });
      }
    },

    *fetchRoles({ payload }, { call, put }) {
      const { ownRoles } = payload;
      const ownRolesIds = ownRoles.map(v => v.roleId);
      const { success, data } = yield call(getRoles);
      if (success) {
        const notOwnRoles = data.filter(v => ownRolesIds.indexOf(v.roleId) === -1);

        yield put({
          type: 'save',
          payload: {
            roles: data,
            notOwnRoles,
            ownRoles,
          },
        });
      }
    },

    *getRolesByUserId({ payload }, { call, put }) {
      const { userId } = payload;
      const { success, data } = yield call(getRolesByUserId, userId);
      if (success) {
        yield put({
          type: 'fetchRoles',
          payload: {
            ownRoles: data,
          },
        });

        // yield put({
        //     type: 'save',
        //     payload: {
        //         ownRoles: data
        //     }
        // });
      }
    },

    *changeUserRoles({ payload }, { call, put }) {
      const { roleIds, type, userId } = payload;
      const method = type === 'up' ? 'DELETE' : 'POST';
      const { success } = yield call(changeUserRoles, userId, roleIds, method);
      if (success) {
        yield put({
          type: 'getRolesByUserId',
          payload: {
            userId,
          },
        });
        message.success(i18n(type === 'up' ? 'MULTITENANCYUSERMGR_DEGRANT_ROLE_SUCCESS' : 'MULTITENANCYUSERMGR_GRANT_ROLE_SUCCESS'));
      }
    },

    *resetPwd({ payload }, { call }) {
      const { userId } = payload;
      const { success, data } = yield call(resetPwd, userId);
      if (success && data === 'success') {
        message.success(i18n('MULTITENANCYUSERMGR_RESET_PASSWD_SUCCESS'));
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
